import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const rotatingTexts = [
  'Elevate your driving experience with precision-engineered rubber designed for maximum grip and cornering stability.',
  'From track-ready performance to smooth city cruising-find the perfect set to unlock your vehicles full potential',
  'Engineered for the road ahead. Experience superior traction and shorter braking distances with our premium tire selection.',
  'Fast, affordable mobile tire changes anywhere in NYC. Your safety is our priority. Professional fitting and balancing by experts who care about the details as much as you do',
];

const Hero = () => {
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState(false);
  const [textIndex, setTextIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    setTimeout(() => setLoaded(true), 100);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimating(true);
      setTimeout(() => {
        setTextIndex(i => (i + 1) % rotatingTexts.length);
        setAnimating(false);
      }, 500);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div style={styles.hero}>
      {/* Background Image with overlay */}
      <div style={styles.bgImage} />
      <div style={styles.overlay} />

      <div style={styles.content}>
        <div className={loaded ? 'animate-fadeInUp delay-1' : ''} style={styles.tagWrapper}>
          <span style={styles.tag}>🏎️ PREMIUM AUTOMOTIVE STORE</span>
        </div>

        <h1 className={loaded ? 'animate-fadeInUp delay-2' : ''} style={styles.heading}>
          Premium Tires &<br />
          <span style={styles.highlight}>Alloy Wheels</span>
          <br />for Every Journey
        </h1>

        {/* Animated rotating text */}
        <div style={styles.rotatingTextBox}>
          <p style={{
            ...styles.rotatingText,
            opacity: animating ? 0 : 1,
            transform: animating ? 'translateX(-40px)' : 'translateX(0)',
            transition: 'opacity 0.5s ease, transform 0.5s ease'
          }}>
            {rotatingTexts[textIndex]}
          </p>
        </div>

        <div className={loaded ? 'animate-fadeInUp delay-4' : ''} style={styles.buttons}>
          <button
            style={styles.primaryBtn}
            onClick={() => navigate('/products')}
            onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
            onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
          >
            Shop Tires →
          </button>
          <button
            style={styles.secondaryBtn}
            onClick={() => scrollTo('finder')}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.15)'}
            onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.08)'}
          >
            🔍 Find Your Tire
          </button>
        </div>

        <div className={loaded ? 'animate-fadeInUp delay-5' : ''} style={styles.stats}>
          {[
            { num: '35+', label: 'Products' },
            { num: '6+', label: 'Top Brands' },
            { num: '100%', label: 'Genuine' },
            { num: '24/7', label: 'Support' },
          ].map((stat, i) => (
            <div key={i} style={styles.stat}>
              <h3 style={styles.statNum}>{stat.num}</h3>
              <p style={styles.statLabel}>{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const styles = {
  hero: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden',
    padding: '80px 20px'
  },
  bgImage: {
    position: 'absolute',
    inset: 0,
    backgroundImage: 'url(https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1600&q=80)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    filter: 'brightness(0.35)',
    zIndex: 0
  },
  overlay: {
    position: 'absolute',
    inset: 0,
    background: 'linear-gradient(135deg, rgba(26,58,92,0.85) 0%, rgba(196,30,58,0.25) 100%)',
    zIndex: 1
  },
  content: {
    textAlign: 'center',
    zIndex: 2,
    maxWidth: '800px',
    position: 'relative'
  },
  tagWrapper: { marginBottom: '20px' },
  tag: {
    background: 'rgba(255,255,255,0.1)',
    color: '#fff',
    fontSize: '12px',
    fontWeight: 'bold',
    letterSpacing: '2px',
    padding: '8px 20px',
    borderRadius: '20px',
    border: '1px solid rgba(255,255,255,0.2)',
    backdropFilter: 'blur(10px)'
  },
  heading: {
    fontSize: '58px',
    fontWeight: '900',
    color: '#fff',
    lineHeight: 1.15,
    marginBottom: '20px',
    textShadow: '0 2px 20px rgba(0,0,0,0.3)'
  },
  highlight: { color: '#c41e3a' },
  rotatingTextBox: {
    minHeight: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '36px',
    overflow: 'hidden'
  },
  rotatingText: {
    color: 'rgba(255,255,255,0.85)',
    fontSize: '18px',
    lineHeight: 1.7,
    maxWidth: '600px',
    margin: '0 auto'
  },
  buttons: {
    display: 'flex',
    gap: '16px',
    justifyContent: 'center',
    marginBottom: '60px',
    flexWrap: 'wrap'
  },
  primaryBtn: {
    padding: '16px 40px',
    background: '#c41e3a',
    color: '#fff',
    border: 'none',
    borderRadius: '10px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    boxShadow: '0 4px 20px rgba(196,30,58,0.4)',
    transition: 'transform 0.2s'
  },
  secondaryBtn: {
    padding: '16px 40px',
    background: 'rgba(255,255,255,0.08)',
    color: '#fff',
    border: '2px solid rgba(255,255,255,0.3)',
    borderRadius: '10px',
    fontSize: '16px',
    cursor: 'pointer',
    backdropFilter: 'blur(10px)',
    transition: 'background 0.2s'
  },
  stats: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '48px',
    background: 'rgba(255,255,255,0.08)',
    padding: '24px 48px',
    borderRadius: '16px',
    boxShadow: '0 4px 24px rgba(0,0,0,0.2)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255,255,255,0.1)',
    flexWrap: 'wrap'
  },
  stat: { textAlign: 'center' },
  statNum: { color: '#c41e3a', fontSize: '28px', fontWeight: 'bold', margin: 0 },
  statLabel: { color: 'rgba(255,255,255,0.7)', fontSize: '13px', margin: '4px 0 0' }
};

export default Hero;